export default "__VITE_ASSET__DORAkgd9__"